import { render, staticRenderFns } from "./DashboardPersonal.vue?vue&type=template&id=64f748ce&scoped=true"
import script from "./DashboardPersonal.vue?vue&type=script&lang=js"
export * from "./DashboardPersonal.vue?vue&type=script&lang=js"
import style0 from "./DashboardPersonal.vue?vue&type=style&index=0&id=64f748ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f748ce",
  null
  
)

export default component.exports